import { useEffect, useMemo, useState } from "react";

export const radioCollection = [
  {
    title: "Chill Radio - Lofi hip hop",
    id: "QfNwhdnErEM",
    cover: "https://media.giphy.com/media/gH1jGsCnQBiFHWMFzh/giphy.gif",
  },
  {
    title: "Chill Drive - Lofi hip hop mix",
    id: "i43tkaTXtwI",
    cover: "https://media.giphy.com/media/ckr4W2ppxPBeIF8dx4/giphy.gif",
  },
  {
    title: "Quiet - Lofi Keep You Safe",
    id: "JdqL89ZZwFw",
    cover: "https://media.giphy.com/media/ZCZ7FHlu3sPek3h0zP/giphy.gif",
  },
  {
    title: "Lofi hip hop",
    id: "8eZETFm5SOY",
    cover: "https://media.giphy.com/media/pVGsAWjzvXcZW4ZBTE/giphy.gif",
  },
  {
    title: "Morning Coffee ☕️",
    id: "1fueZCTYkpA",
    cover: "https://media.giphy.com/media/N3yLGQ1oMYfGU/giphy.gif",
  },
  {
    title: "Study Work",
    id: "zAKWiGAwvy0",
    cover:
      "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExb3czaHhpNXJlanJobW9lOXNxMnBjMDQ1M3dwYjdxdndtc3RnY3lwZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/RIpj8HJGVGGTUdM76b/giphy.gif",
  },
  {
    title: "lofi beats",
    id: "Lg21MW4_suQ",
    cover: "https://media.giphy.com/media/5e25aUTZPcI94uMZgv/giphy.gif",
  },
  {
    title: "MEOWLODY",
    id: "2y8EcGq5rlc",
    cover: "https://media.giphy.com/media/9B7XwCQZRQfQs/giphy.gif",
  },
  {
    title: "Cyberpunk 2077 City radio ",
    id: "SE5BHLzaC1I",
    cover: "https://media.giphy.com/media/NKEt9elQ5cR68/giphy.gif",
  },
];

export const useRadio = () => {
  const maxIndex = radioCollection.length;
  let [index, setIndex] = useState(0);

  const radio = useMemo(() => radioCollection[index], [index]);

  const resetIndex = () => {
    setIndex(0);
  };

  const setMaxIndex = () => {
    setIndex(maxIndex - 1);
  };

  const getNextRadio = () => {
    if (index >= maxIndex - 1) {
      resetIndex();
      return;
    }
    setIndex(index + 1);
  };

  const getPreviousRadio = () => {
    if (index - 1 < 0) {
      setMaxIndex();
      return;
    }
    setIndex(index - 1);
  };

  return {
    getNextRadio,
    getPreviousRadio,
    radio,
  };
};
